<template>
	<header class="container-fluid no-gutters fixed-top">
		<nav class="navbar navbar-expand-md navbar-light">
			<div class="header-block container">
				<div class="headcontents d-flex justify-content-between w-100 row">
					<div id="logo" class="col-5 col-sm-6 text-left align-self-center pr-0">
						<a href="/">
							<img src="/images/k1stlogo_color-8.png">
						</a>
					</div>
					<div class="col-7 col-sm-6 no-gutters before_login d-flex justify-content-end">
						<a :href="cart+'/v2/member/MyPage.aspx?ccode=K1ST'"
							class="btn btn-header head-link">
							<span>
								<i aria-hidden="true" class="fas fa-sign-in-alt"></i>
								<!-- <br class ="d-md-none"> -->
								<span class="link-text">新規登録 / ログイン</span>
							</span>
						</a>
						<a :href="cart+'/v2/ShoppingCart.aspx?scode=K1ST'"
							class="btn btn-header head-link">
							<span>
								<i aria-hidden="true" class="fas fa-shopping-cart"></i>
								<!-- <br class="d-md-none"> -->
								<span class="link-text">カート</span>
							</span>
						</a>
					</div>
					<div class="text-right no-gutters after_login">
						<a :href="cart+'/system/set_auth?action=logout'"
							class="btn btn-header head-link">
							<span>
								<i aria-hidden="true" class="fas fa-sign-out-alt"></i>
								<span class="link-text">ログアウト</span>
							</span>
						</a>
						<a :href="cart+'/v2/ShoppingCart.aspx?scode=K1ST'"
							class="btn btn-header head-link">
							<span>
								<i aria-hidden="true" class="fas fa-shopping-cart"></i>
								<span class="link-text">カート</span>
							</span>
						</a>
					</div>
				</div>
			</div>
		</nav>
	</header>
</template>

<style>
	.headcontents{
		align-items: center;
		margin: .5rem 0;
	}
	.navbar{
		padding: 0.375rem .2rem !important;
	}
	.header-block{
		max-width: unset !important;
	}
	.head-link{
		min-width: 10vw;
	}
	.link-text{
		letter-spacing: 0.07rem;
		white-space: nowrap;
		font-size: .8rem;
	}
	.head-link i{
		/*margin: unset !important;*/
		margin-right: .3rem !important;
	}
	@media(max-width: 1024px){
		.head-link i{
			/*margin-right: .7rem !important;*/
		}
		.head-link{
			width: auto;
			/*max-width: 10vw;*/
		}
	}
	@media(min-width: 768px){
		.head-link{
			/*max-width: unset;*/
		}
	}
	@media(max-width: 767px){
		.headcontents{
			margin: .2rem 0;
		}
		.head-link i{
			/*margin: unset !important;*/
			/*margin-right: .3rem !important;*/
		}
		.head-link{
			padding: .7rem .3rem;
			font-size: .5rem;
			max-width: unset;
		}
		.link-text{
			font-size: .5rem;
		}
	}
	@media(max-width: 350px){
		.head-link{
			padding: .35rem .3rem;
		}
		.link-text{
			letter-spacing: unset;
		}
	}
</style>

<script>
	export default{
		data(){
			return{
				cart:process.env.VUE_APP_CARTURI,
			}
		},
	}
</script>